import { Card } from '@equinor/eds-core-react';
import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';
import { theme } from '../../../tokens/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacings.LARGE};
  padding: ${spacings.X_LARGE};
  max-width: 1600px;
  width: 100%;
  box-sizing: border-box;
  min-height: 100%;
  background-color: ${theme.light.ui.background.default};
`;

export const ScenarioSelector = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${spacings.MEDIUM};
  padding: ${spacings.LARGE};
  border: 1px solid ${theme.light.ui.background.medium};
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: ${spacings.LARGE};
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const FullWidthRow = styled.div`
  grid-column: 1 / -1;
  min-width: 0;
  overflow: visible;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${spacings.XX_LARGE};
  gap: ${spacings.MEDIUM};
  text-align: center;
`;
